import type { Reducer } from 'redux';
import { Actions } from '@/redux/campaign/actions';
import type { CampaignState, CampaignAction } from '@/redux/campaign/types';

export const initialState = { gameIndex: 0, translations: {} } as CampaignState;

export default ((state = initialState, action: CampaignAction) => {
  switch (action.type) {
    case Actions.SetGameIndex:
      return { ...state, ...{ gameIndex: action.index } };

    case Actions.SetGameIndexFail:
      return { ...state, error: action.error };

    case Actions.SetCurrentTime:
      return { ...state, ...{ currentTime: action.time } };

    case Actions.SetCurrentTimeFail:
      return { ...state, error: action.error };

    case Actions.SetCampaignData:
      return { ...state, ...action.data };

    case Actions.SetCampaignDataFail:
      return { ...state, error: action.error };

    default:
      return state;
  }
}) as Reducer<CampaignState, CampaignAction>;
